import { API_URL, HTTP_HEADERS } from 'constants/apis';

const getPendoMetadata = async () => {
	const { PENDO_SERVICE, APIM_ROOT } = API_URL;
	const _url = `${APIM_ROOT(PENDO_SERVICE)}/v1/metadata`;
	const response = await fetch(_url, HTTP_HEADERS().GET);
	if (response.ok) return response.json();
	else return '';
};

export default async function useRegisterPendoMetadata(
	isUserLoggedIn,
	nodeEnvironment
) {
	if (!isUserLoggedIn || nodeEnvironment === 'development') return;
	let pendoServiceMetadata = await getPendoMetadata();
	if (Boolean(pendoServiceMetadata) && window.pendo.accountId === undefined) {
		console.info('Initializing Pendo');
		window.pendo &&
			window.pendo.initialize({
				apiKey: '8621d39c-8c6f-413e-67b0-74762f2cca48',
				visitor: pendoServiceMetadata,
				account: {
					id: pendoServiceMetadata.clientId,
					name: pendoServiceMetadata.clientName
				}
			});
	}
}
